document.addEventListener("DOMContentLoaded", () => {

  const canvas = document.getElementById("jersey-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  const nameInput = document.getElementById("jersey_name");
  const numberInput = document.getElementById("jersey_number");
  // const hiddenInput = document.getElementById("preview-image-input");
  const form = document.querySelector('form[action="/cart/add"]');

  const img = new Image();
  let lastSrc = "";
  let lastTeam = "";

  const META = window.TSHIRT_META || [];

  /* ================= TEAM ================= */

  function getSelectedTeam() {
    let value = "";

    const radio = document.querySelector('input[type="radio"]:checked');
    if (radio) value = radio.value.toLowerCase();

    const select = document.querySelector('select[name="id"]');
    if (!value && select) {
      value = select.options[select.selectedIndex]?.text.toLowerCase() || "";
    }

    if (value.includes("/")) {
      value = value.split("/")[0].trim();
    }

    return value;
  }

  /* ================= META ================= */

  function getMetaData() {
    const team = getSelectedTeam();

    for (let item of META) {
      if (team && item.title && team.includes(item.title.toLowerCase())) {
        return item;
      }
    }

    return null;
  }

  /* ================= IMAGE ================= */

  function updateVariantImage() {

    const meta = getMetaData();
    const team = getSelectedTeam();

    if (!meta || !meta.image) return;

    if (team === lastTeam && meta.image === lastSrc) return;

    lastTeam = team;
    lastSrc = meta.image;

    img.onload = () => draw();
    img.onerror = () => console.log("image failed");

    img.src = meta.image + "?t=" + Date.now();
  }

  /* ================= CANVAS SIZE ================= */

  function resizeCanvas() {
    const w = canvas.clientWidth;
    const h = w;

    canvas.width = w * 2;
    canvas.height = h * 2;

    ctx.setTransform(2, 0, 0, 2, 0, 0);
  }

  /* ================= TEXT WRAP ================= */

  function getWrappedLines(text, baseSize, maxWidth, forceCharWrap = false) {

    const meta = getMetaData();    
    const fontStyle = meta?.font_style || "Bebas Neue, Impact";

    text = (text || "").toUpperCase();

    const temp = document.createElement("canvas").getContext("2d");
    temp.font = `900 ${baseSize}px ${fontStyle}`;

    let lines = [];

    if (forceCharWrap || !text.includes(" ")) {

      let current = "";

      for (let char of text) {
        let test = current + char;

        if (temp.measureText(test).width < maxWidth) {
          current = test;
        } else {
          lines.push(current);
          current = char;
        }
      }

      if (current) lines.push(current);

    } else {

      let words = text.split(" ");
      let current = "";

      for (let w of words) {
        let test = current ? current + " " + w : w;

        if (temp.measureText(test).width < maxWidth) {
          current = test;
        } else {
          lines.push(current);
          current = w;
        }
      }

      if (current) lines.push(current);
    }

    return lines;
  }

  /* ================= DRAW ================= */

  function draw() {

    if (!img.complete) return;

    const meta = getMetaData();    
    const teamColor = meta?.color || "#000";
    const borderColor = meta?.border_color || "";
    const fontStyle = meta?.font_style || "Bebas Neue, Impact";
    const topGap = meta?.topgap || "";
    const gapParsed = JSON.parse(topGap);
    
    const W = canvas.width / 2;
    const H = canvas.height / 2;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, W, H);

    let rawName = (nameInput?.value || "").substring(0, 10).toUpperCase();
    let number = (numberInput?.value || "").replace(/\D/g, "").substring(0, 3);

    numberInput.value = number;

    const centerX = W / 2;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.lineJoin = "round";

    /* ================= NUMBER ================= */

    const numSize =
      number.length === 3 ? W * 0.25 :
      number.length === 2 ? W * 0.30 :
      W * 0.33;

    let numberY;

    let one_digit=parseFloat(gapParsed["1"]) ||0.62;
    let two_digit=parseFloat(gapParsed["2"]) || 0.60;
    let three_digit=parseFloat(gapParsed["3"]) || 0.58; 

    if (number.length === 1) {
      numberY = H * one_digit;
    } else if (number.length === 2) {
      numberY = H * two_digit;
    } else {
      numberY = H * three_digit;
    }

    ctx.font = `900 ${numSize}px ${fontStyle}`;

    ctx.shadowColor = "rgba(0,0,0,0.15)";
    ctx.shadowBlur = 6;
    ctx.shadowOffsetY = 2;

    ctx.strokeStyle = borderColor;
    ctx.lineWidth = numSize * 0.03;

    ctx.strokeText(number, centerX, numberY);
    ctx.fillStyle = teamColor;
    ctx.fillText(number, centerX, numberY);

    ctx.shadowColor = "transparent";

    /* ================= NAME ================= */

    const noSpaceName = !rawName.includes(" ");
    const baseSize = noSpaceName ? W * 0.06 : W * 0.08;

    const maxWidth = W * 0.4;

    let size = baseSize;
    let lines = getWrappedLines(rawName, size, maxWidth, noSpaceName);

    ctx.font = `900 ${size}px ${fontStyle}`;

    while (
      lines.some(l => ctx.measureText(l).width > maxWidth) &&
      size > 10
    ) {
      size -= 2;
      ctx.font = `900 ${size}px ${fontStyle}`;
      lines = getWrappedLines(rawName, size, maxWidth, noSpaceName);
    }

    const lineHeight = size * 1;

    let gapMultiplier;

    if (number.length === 1) gapMultiplier = 0.50;
    else if (number.length === 2) gapMultiplier = 0.55;
    else gapMultiplier = 0.68;

    /* FIX: NO TOP CUT - TOP ALIGNED BLOCK */
    let nameStartY = numberY + (numSize * gapMultiplier);

    const minSafeY = H * 0.25;
    nameStartY = Math.max(nameStartY, minSafeY);
    

    ctx.strokeStyle = borderColor;
    ctx.lineWidth = size * 0.05;

    lines.forEach((line, i) => {
      const y = nameStartY + (i * lineHeight);

      ctx.strokeText(line, centerX, y);
      ctx.fillStyle = teamColor;
      ctx.fillText(line, centerX, y);
    });
  }

  /* ================= INPUT ================= */

  let debounce;
  function update() {
    clearTimeout(debounce);
    debounce = setTimeout(draw, 30);
  }

  nameInput?.addEventListener("input", update);
  numberInput?.addEventListener("input", update);

  /* ================= WATCH ================= */

  setInterval(updateVariantImage, 300);

  /* ================= SAVE ================= */

  form?.addEventListener("submit", () => {
    // try {
    //   hiddenInput.value = canvas.toDataURL("image/png");
    // } catch {}
  });

  /* ================= INIT ================= */

  resizeCanvas();

  window.addEventListener("resize", () => {
    resizeCanvas();
    draw();
  });

  setTimeout(updateVariantImage, 400);

});